"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.emitter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _events = _interopRequireDefault(require("events"));

var _Menu = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Menu"));

var _Drawer = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Drawer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emitter = new _events.default();
exports.emitter = emitter;

var PopupSubMenu = /*#__PURE__*/function (_Component) {
  _inherits(PopupSubMenu, _Component);

  var _super = _createSuper(PopupSubMenu);

  function PopupSubMenu(props) {
    var _this;

    _classCallCheck(this, PopupSubMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false,
      left: 200
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      _this.setState({
        visible: false
      });
    });

    _this.eventEmitter = emitter;
    _this.closeMenu = _this.closeMenu.bind(_assertThisInitialized(_this));
    _this.handleAfterVisibleChange = _this.handleAfterVisibleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PopupSubMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.on("PopupSubMenu:open", this.closeMenu);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.off("PopupSubMenu:open", this.closeMenu);
    }
  }, {
    key: "on",
    value: function on(eventName, listener) {
      this.eventEmitter.on(eventName, listener);
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      this.eventEmitter.removeListener(eventName, listener);
    }
  }, {
    key: "closeMenu",
    value: function closeMenu(level) {
      if (!this.state.visible) return;

      if (level === null || level === undefined || this.props.level === level) {
        return this.setState({
          visible: false
        });
      }
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick() {
      !this.state.visible && this.eventEmitter.emit("PopupSubMenu:open", this.props.level);
      this.setState(function (state) {
        return {
          visible: !state.visible
        };
      });
    }
  }, {
    key: "handleAfterVisibleChange",
    value: function handleAfterVisibleChange() {
      if (!this.menuItem) {
        return;
      }

      var el = _reactDom.default.findDOMNode(this.menuItem);

      if (!el) {
        return;
      }

      var pos = el.getBoundingClientRect();
      return this.setState({
        left: pos.left + pos.width
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          menu = _this$props.menu,
          children = _this$props.children,
          title = _this$props.title,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["menu", "children", "title", "id"]);

      var left = this.state.left; // const divProps = {};

      var childrenWithProps = _react.default.Children.map(children, function (child) {
        return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread(_objectSpread({}, rest), {}, {
          level: 0
        }));
      });

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Menu.default.Item, _extends({
        key: id
      }, rest, {
        onClick: function onClick(ev) {
          return _this2.handleMenuClick(menu);
        },
        ref: function ref(_ref) {
          return _this2.menuItem = _ref;
        }
      }), title, /*#__PURE__*/_react.default.createElement("span", null, " ")), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        className: this.state.visible ? "" : "d-none",
        style: {
          left: left
        } // getContainer={this.drawer}
        ,
        title: menu.title,
        placement: "left",
        closable: true,
        visible: this.state.visible,
        onClose: this.onClose,
        width: 300,
        afterVisibleChange: this.handleAfterVisibleChange
      }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
        theme: "light",
        mode: "inline",
        className: "side-menu"
      }, childrenWithProps)));
    }
  }]);

  return PopupSubMenu;
}(_react.Component);

exports.default = PopupSubMenu;